
import {WOW} from '../../../node_modules/wowjs/dist/wow';



new WOW().init();
$(window).resize(function (){// 绑定到窗口缩放的事件
  
});

// $(".nei-nav a").click(function() {
//   $(this).addClass("active").siblings().removeClass("active");
//   let id = $(this).attr("href").split("#").pop()
//   var top = $('#' + id).offset().top;
//   $('html,body').animate({
//       scrollTop: top - 150
//   }, 500);
// })
const observer = new IntersectionObserver((entries) => {
entries.forEach(entry => {
if (entry.isIntersecting) {
const img = entry.target;
img.src = img.dataset.src;
observer.unobserve(img);
}
});
}, { rootMargin: '200px' }); // 预加载200px
document.querySelectorAll('img[data-src]').forEach(img => observer.observe(img));
